import React from "react"
import WOW from "react-wow"
import { Container, Row, Col } from "@bootstrap-styled/v4"
import { StaticQuery, graphql } from "gatsby"

import * as S from "./styled"

const TechnologiesList = () => (
  <StaticQuery
    query={graphql`
      query {
        javascriptImage: file(relativePath: { eq: "brands/javascript.png" }) {
          childImageSharp {
            fluid(maxWidth: 300) {
              ...GatsbyImageSharpFluid
            }
          }
        }
        reactImage: file(relativePath: { eq: "brands/react.png" }) {
          childImageSharp {
            fluid(maxWidth: 300) {
              ...GatsbyImageSharpFluid
            }
          }
        }

        graphqlImage: file(relativePath: { eq: "brands/graphql.png" }) {
          childImageSharp {
            fluid(maxWidth: 300) {
              ...GatsbyImageSharpFluid
            }
          }
        }

        nodeImage: file(relativePath: { eq: "brands/node.png" }) {
          childImageSharp {
            fluid(maxWidth: 300) {
              ...GatsbyImageSharpFluid
            }
          }
        }

        shopifyImage: file(relativePath: { eq: "brands/shopify.png" }) {
          childImageSharp {
            fluid(maxWidth: 300) {
              ...GatsbyImageSharpFluid
            }
          }
        }

        awsImage: file(relativePath: { eq: "brands/aws.png" }) {
          childImageSharp {
            fluid(maxWidth: 300) {
              ...GatsbyImageSharpFluid
            }
          }
        }
      }
    `}
    render={data => {
      return (
        <S.TechnologiesListWrapper>
          <S.TechnologiesListHeader>
            <S.TechnologiesListSubTitle>
              As melhores tecnologias
            </S.TechnologiesListSubTitle>
            <S.TechnologiesListTitle>
              Para as melhores aplicações
            </S.TechnologiesListTitle>
          </S.TechnologiesListHeader>

          <S.TechnologiesListList>
            <Row>
              <WOW animation="fadeIn">
                <Col xs={4} md={2}>
                  <S.TechnologiesListItem>
                    <S.TechnologiesListItemImage
                      alt={"Logo Javascript"}
                      title={"Javascript"}
                      fluid={data.javascriptImage.childImageSharp.fluid}
                    />
                  </S.TechnologiesListItem>
                </Col>
              </WOW>

              <WOW animation="fadeIn">
                <Col xs={4} md={2}>
                  <S.TechnologiesListItem>
                    <S.TechnologiesListItemImage
                      alt={"Logo React"}
                      title={"React"}
                      fluid={data.reactImage.childImageSharp.fluid}
                    />
                  </S.TechnologiesListItem>
                </Col>
              </WOW>

              <WOW animation="fadeIn">
                <Col xs={4} md={2}>
                  <S.TechnologiesListItem>
                    <S.TechnologiesListItemImage
                      alt={"Logo AWS"}
                      title={"AWS"}
                      fluid={data.awsImage.childImageSharp.fluid}
                    />
                  </S.TechnologiesListItem>
                </Col>
              </WOW>

              <WOW animation="fadeIn">
                <Col xs={4} md={2}>
                  <S.TechnologiesListItem>
                    <S.TechnologiesListItemImage
                      alt={"Logo GraphQL"}
                      title={"GraphQL"}
                      fluid={data.graphqlImage.childImageSharp.fluid}
                    />
                  </S.TechnologiesListItem>
                </Col>
              </WOW>

              <WOW animation="fadeIn">
                <Col xs={4} md={2}>
                  <S.TechnologiesListItem>
                    <S.TechnologiesListItemImage
                      alt={"Logo Node"}
                      title={"Node"}
                      fluid={data.nodeImage.childImageSharp.fluid}
                    />
                  </S.TechnologiesListItem>
                </Col>
              </WOW>

              <WOW animation="fadeIn">
                <Col xs={4} md={2}>
                  <S.TechnologiesListItem>
                    <S.TechnologiesListItemImage
                      alt={"Logo Shopify"}
                      title={"Shopify"}
                      fluid={data.shopifyImage.childImageSharp.fluid}
                    />
                  </S.TechnologiesListItem>
                </Col>
              </WOW>
            </Row>
          </S.TechnologiesListList>
        </S.TechnologiesListWrapper>
      )
    }}
  />
)

export default TechnologiesList
